import s from "styled-components";
import { SectHead } from "../styled";
import { Button as BaseButton } from "_c/button";

export const Wrap = s.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 110px;
  padding-bottom: 25px;
  @media(max-width: 500px) {
    margin-top: 60px;
  }
`;
export const Head = s(SectHead)`
  width: 80%;
  margin: 0 auto;
  h3 {
    margin-top: 0;
  }
  @media(max-width: 450px) {
    width: 95%;
  }
`;
export const InnerWrap = s.div`
  padding-top: 60px;
`;
export const TextWrap = s.div`
  margin-top: 15px;
  flex: 1;
  margin-left: 70px;
  h4 {
    color: var(--color-cta);
    font-size: 30px;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 15px;
  }
  p {
    font-size: 16px;
    font-weight: 500;
    line-height: 32px;
    color: var(--font-color-main);
    margin: 0;
  }
  section {
    display: flex;
    flex-direction: column;
    margin-bottom: 45px; 
  }
  strong {
    font-weight: 700;
    color: var(--color-primary);
    text-decoration: underline;
    margin: 13px 0;
  }
  @media(max-width: 1200px) {
    margin-left: 0;
    margin-top: 50px;
    text-align: center;
    p {
      max-width: 550px;
    }
  }
`;
export const ContentWrap = s.div`
  max-width: 1366px;
  margin: 0 auto;
  display: flex;
  padding: 0 15px;
  @media(max-width: 1199px) {
    flex-direction: column;
    align-items: center;
  }
`;
export const Button = s(BaseButton)`
  padding: 15px 40px;
`;
export const SliderAndVideoWrap = s.div`
  width: 660px;
  min-width: 660px;
  @media(max-width: 991px) {
    width: 550px;
    min-width: 550px;
  }
  @media(max-width: 570px) {
    width: 315px;
    min-width: 315px;
  }
`;
export const SliderWrap = s.div`
  position: relative;
  width: 100%;
  height: 373px;
  margin-top: 0px;
  @media(max-width: 991px) {
    height: 701px;
  }
  @media(max-width: 570px) {
    height: 586px;
  }
`;
export const Mockup = s.figure`
  margin: 0;
  background: url(/mockups/notebook-mockup.svg) no-repeat top left;
  background-size: contain;
  width: 100%;
  height: 100%;
  position: absolute;
  pointer-events: none;
  left: 0;
  top: 0;
  z-index: 2;
  @media(max-width: 991px) {
    background-image: url(/mockups/tablet-mockup.svg);
  }
  @media(max-width: 570px) {
    background-image: url(/mockups/phone-mockup.svg);
  }
`;
export const Slider = s.div`
  position: absolute;
  left: 50px;
  top: 16px;
  width: 560px;
  @media(max-width: 991px) {
    left: 16px;
    width: 518px;
  }
  @media(max-width: 570px) {
    left: 9px;
    top: 58px;
    width: 297px;
  }
`;
export const Slide = s.img`
  width: 100%;
  height: 331px;
  object-fit: cover;
  @media(max-width: 991px) {
    height: 625px;
  @media(max-width: 570px) {
    height: 471px;
  }
`;
